/**
 * Typography configuration: maps varnish-theme font tokens to MUI typography options.
 * @see https://mui.com/material-ui/customization/typography/
 */
import varnishTokens from '@allenai/varnish-theme/mui';
import type { TypographyVariantsOptions } from '@mui/material/styles';

export const typography = {
    fontFamily: varnishTokens.font.family.body.value,
    fontWeightLight: varnishTokens.font.weight.light.value,
    fontWeightRegular: varnishTokens.font.weight.regular.value,
    fontWeightMedium: varnishTokens.font.weight.medium.value,
    fontWeightSemiBold: varnishTokens.font.weight.semiBold.value,
    fontWeightBold: varnishTokens.font.weight.bold.value,
    h1: varnishTokens.typography.h1.value,
    h2: varnishTokens.typography.h2.value,
    h3: varnishTokens.typography.h3.value,
    h4: varnishTokens.typography.h4.value,
    h5: varnishTokens.typography.h5.value,
    h6: varnishTokens.typography.h6.value,
    subtitle1: varnishTokens.typography.subtitle1.value,
    subtitle2: varnishTokens.typography.subtitle2.value,
    body1: varnishTokens.typography.body1.value,
    body2: varnishTokens.typography.body2.value,
    caption: varnishTokens.typography.caption.value,
    overline: varnishTokens.typography.overline.value,
    monospace: varnishTokens.typography.monospace.value,
    button: {
        textTransform: 'none',
    },
} satisfies TypographyVariantsOptions;
